module.exports = __webpack_public_path__ + "static/media/location.8012e7da.svg";